import { Navigate, RouteObject } from "react-router-dom";
import { featureFlags } from "../../featureFlags";
import { OrdersFilterInner, path as filterPath } from "./OrdersFilter";
import { withHandle } from "../../utils/route.util";
import { OrdersView } from "./OrdersView";
import { OrdersViewV2 } from "./OrdersViewV2";
import { OrderViewV2 } from "./OrderViewV2";
import { OrderDetailsTab } from "./tabs/OrderDetailsTab";
import { OrderItemsTab } from "./tabs/OrderItemsTab";
import { OrderEventLogsTab } from "./tabs/OrderEventLogsTab";
import { OrderShipmentsTab } from "./tabs/OrderShipmentsTab";
import { OrderView } from "./OrderView";
import { OrderItemView } from "./OrderItemView";

export const orderFiltersRoute: RouteObject = {
  path: filterPath,
  element: <OrdersFilterInner />,
};

const orderDetailTabs: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="details" replace />,
  },
  {
    path: "details",
    element: <OrderDetailsTab />,
  },
  {
    path: "items",
    element: <OrderItemsTab />,
  },
  {
    path: "event-logs",
    element: <OrderEventLogsTab />,
  },
  {
    path: "shipments",
    element: <OrderShipmentsTab />,
  },
  {
    path: "*",
    element: <Navigate to="details" replace />,
  },
];

export const ordersRoutes: RouteObject[] = featureFlags.newOrderManagement
  ? [
      {
        path: "orders",
        element: <OrdersViewV2 />,
        ...withHandle("orders"),
        children: [orderFiltersRoute],
      },
      {
        path: "orders/:customerPublicId/:customerOrderId",
        element: <OrderViewV2 />,
        ...withHandle("order-detail", { navigateOnSandboxToggle: "/dashboard/orders" }),
        children: orderDetailTabs,
      },
    ]
  : [
      {
        path: "orders",
        element: <OrdersView />,
        ...withHandle("orders"),
      },
      {
        path: "orders/:customerPublicId/:customerOrderId",
        element: <OrderView />,
        ...withHandle("order-detail", { navigateOnSandboxToggle: "/dashboard/orders" }),
      },
      {
        path: "orders/:customerPublicId/:customerOrderId/items/:itemId",
        element: <OrderItemView />,
        ...withHandle("order-item"),
      },
    ];
